module.exports = __webpack_public_path__ + "img/news0.2e32ad8b.png";